module.exports = __webpack_public_path__ + "static/media/info-icon-dark.6832ed5e.svg";